import Helper from '@/utils/helper'

class SoftwareSettings {
  constructor ({ id, hideCursor }) {
    this.id = Helper.getValue(id)
    this.hideCursor = Boolean(Helper.getValue(hideCursor))
  }

  getId () {
    return this.id
  }

  hasHideCursor () {
    return this.hideCursor
  }
}

export default SoftwareSettings
